import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { Link } from 'react-router';
import routes from 'routes';
import { Search_searchCompanies } from 'types/apollo/Search';

interface CompanySearchMetaProps {
  companies: Search_searchCompanies[];
}

export const CompanySearchMeta: FC<CompanySearchMetaProps> = ({ companies }) => {
  return (
    <Card variant="outlined">
      <Box px={2} pt={2}>
        <Typography variant="h5">Companies</Typography>
      </Box>
      <Stack divider={<Divider />} component={List}>
        {companies.length === 0 && (
          <ListItem>
            <ListItemText primary="No Companies Found" />
          </ListItem>
        )}
        {companies.map((company) => {
          const styles = company.exactMatch ? { backgroundColor: '#e2ffe2' } : {};
          const companyName = (
            <>
              <b>{company.id}</b> {company.name}
            </>
          );
          return (
            <ListItemButton
              key={`${company.id}-${company.name}`}
              component={Link}
              to={routes.company.resolve({ id: company.id })}
              sx={styles}
            >
              <ListItemText primary={companyName} />
            </ListItemButton>
          );
        })}
      </Stack>
    </Card>
  );
};
